import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { adminLogin, setAdminToken } from "../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await adminLogin(pw);
      setAdminToken(res.token);
      toast.success("Authenticated");
      nav("/admin");
    } catch (err) {
      toast.error("Invalid password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="admin-login-page">
      <Seo title="Admin login" path="/admin/login" noindex />
      <Header />
      <main className="max-w-md mx-auto px-4 py-12">
        <div className="tv-card">
          <h1 className="text-lg font-bold border-b border-black pb-2">{">"}_ admin login</h1>
          <p className="text-[12px] text-[#666] mt-2">
            Single-password gate. Set <code className="bg-[#f4f4f4] px-1">ADMIN_PASSWORD</code> in backend/.env.
          </p>
          <form onSubmit={onSubmit} className="mt-4 grid gap-3" data-testid="admin-login-form">
            <input
              type="password"
              required
              autoFocus
              className="tv-input"
              placeholder="password"
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              data-testid="admin-password-input"
            />
            <button type="submit" className="tv-btn tv-btn-primary" disabled={busy} data-testid="admin-login-btn">
              {busy ? "[ checking... ]" : "[ login ]"}
            </button>
          </form>
        </div>
      </main>
      <Footer />
    </div>
  );
}
